import { useTranslation } from "react-i18next";
import { useIsMobile } from "../store/user";
import RangeSlider from "./rangeSlider/rangeSlider";
import { useEffect, useState } from "react";
import { getWidgetSettings } from "../serivces/widgetService";

const OuterRangeSlider = ({ data, length, index, color }) => {
  const isMobile = useIsMobile();
  const { t } = useTranslation();
  const [widgetSettings, setWidgetSettings] = useState(null);

  const getWidget = async () => {
    const resp = await getWidgetSettings();
    setWidgetSettings(resp);
  };

  useEffect(() => {
    getWidget();
  }, []);

  const getFunctionValue = (key) => {
    return widgetSettings?.advanced?.functions?.[key];
  };

  const removeSpaceAndCaseSensitive = (str) => {
    return String(str || "")
      .replace(/\s+/g, "")
      .toLowerCase();
  };

  return (
    <>
      {getFunctionValue(removeSpaceAndCaseSensitive(data.fieldName)) && (
        <div
          className={`w-full flex-col bg-setting-card ${
            index === length - 1 ? "mb-[0.938rem]" : ""
          } rounded-[0.75rem] flex items-center justify-between ${
            isMobile
              ? "h-[20.625rem] px-[1.5rem] py-[1.19rem] mt-[1.5rem]"
              : "h-[10rem] px-[0.75rem] py-[1.5rem] mt-[0.94rem]"
          } gap-[1.563rem]`}
        >
          <div className="flex items-center justify-center gap-[1.5rem]">
            <div
              style={{ backgroundImage: `url(${data?.icon})` }}
              className="w-[1.75rem] h-[1.75rem] bg-no-repeat bg-center bg-contain"
              aria-hidden="true"
            />
            <div className="text-primary font-[600] leading-[1.375rem] text-text-black">
              {t(data?.title)}
            </div>
          </div>

          <RangeSlider widgetColor={color} data={data} />
        </div>
      )}
    </>
  );
};

export default OuterRangeSlider;
